import { useState, useEffect, useCallback } from "react";

const THEME_KEY = "blokista_theme";
const ACCENT_KEY = "blokista_accent";

export const ACCENTS = [
  { id: "amber", label: "Amber", c: "#F5A623" },
  { id: "teal", label: "Teal", c: "#14B8A6" },
  { id: "violet", label: "Violet", c: "#8B5CF6" },
];

function currentTheme() {
  return document.documentElement.getAttribute("data-theme") || localStorage.getItem(THEME_KEY) || "dark";
}
function currentAccent() {
  return document.documentElement.getAttribute("data-accent") || localStorage.getItem(ACCENT_KEY) || "amber";
}

export function useTheme() {
  const [theme, setThemeState] = useState(currentTheme);
  const [accent, setAccentState] = useState(currentAccent);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute("data-accent", accent);
    localStorage.setItem(ACCENT_KEY, accent);
  }, [accent]);

  const toggle = useCallback(() => setThemeState((t) => (t === "dark" ? "light" : "dark")), []);
  const setTheme = useCallback((t) => setThemeState(t), []);
  const setAccent = useCallback((a) => setAccentState(a), []);

  return { theme, toggle, setTheme, accent, setAccent };
}
